import Link from "next/link";
import testimonialData from "../../content/home/testimonials.json";

export default function Testimonials() {
  return (
    <section className="bg-gray-100 py-12 px-6">
      <div className="container mx-auto">

        {/* ✅ Why Choose SRK Trends Section */}
        <section className="py-10 px-6">
          <h2 className="text-2xl font-bold mb-6">Why Choose SRK Trends</h2>
          <ul className="list-disc ml-6 text-gray-700 space-y-2 max-w-2xl">
            {testimonialData.whyChooseUs.map((point, idx) => (
              <li key={idx}>{point}</li>
            ))}
          </ul>
        </section>

        {/* ✅ Call to Action Buttons - FIXED for small screens */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8 mb-12">
          <Link
            href="/book-app"
            className="bg-black text-white px-6 py-3 rounded hover:bg-gray-800 transition text-center w-full sm:w-auto"
          >
            Book An Appointment
          </Link>

        </div>

        {/* ✅ Testimonials Section */}
        <h2 className="text-3xl font-bold text-center mb-8">💬 What Our Customers Say</h2>
        <div className="grid md:grid-cols-3 gap-6 text-center">
          {testimonialData.testimonials.map((text, index) => (
            <div key={index} className="bg-white p-6 rounded shadow">
              <p className="italic">“{text}”</p>
              <p className="mt-4 text-sm text-gray-600">— Happy Customer</p>
            </div>
          ))}
        </div>

        {/* ✅ Feedback CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-700 mb-2">
            Have a story or experience with SRK Trends?
          </p>
          <Link
            href="/contact"
            className="inline-block bg-green-600 text-white px-6 py-3 rounded hover:bg-green-700 transition"
          >
            Give Your Feedback
          </Link>
        </div>
      </div>
    </section>
  );
}